import axios from "axios";
const baseUrl=process.env.REACT_APP_API_URL;

export const verifyEnquireOtp  = async(data)=>{
    const url = baseUrl+`/verifyEnquireOtp`;
    try {
     const response=  await axios.post(url,data)
     return response.data
    } catch (error) {
     console.log(error)
    }
 }
export const verifyEnrollOtp  = async(data)=>{
    const url = baseUrl+`/verifyEnrollOtp`;
    try {
     const response=  await axios.post(url,data)
     return response.data
    } catch (error) {
     console.log(error)
    }
 }
